/**
 * Builds the value of the data-mdlfy-cms attribute that makes a database text value
 * editable in the preview. Always pass the real table name, the row id and the column
 * name as it exists in the database (never the camelCase property name).
 */
export const cms = (table: string, id: string, column: string): string => `${table}:${id}:${column}`
